
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselInDistressAis as ObiVesselInDistressAisElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-in-distress-ais.js';
 
 
 

 
 export const ObiVesselInDistressAis = createComponent({
   react: React,
   tagName: 'obi-vessel-in-distress-ais',
   elementClass: ObiVesselInDistressAisElement,
   events: {
     
   }
  });
 
 